import React from "react";

const LoginComp = props => (
  <div>
    <form onSubmit={e => props.submit(e, "login")}>
      <div className="form-group">
        <label>Email</label>
        <input
          type="email"
          name="email"
          placeholder="Email address"
          autoComplete="login-email"
        />
        {props.chk_errors("email")}
      </div>
      <div className="form-group">
        <label>Password</label>
        <div className="credential_password">
          <input
            type={props.show_password ? "text" : "password"}
            name="password"
            placeholder="Password"
            autoComplete="login-password"
          />
          <i
            className={props.show_password ? "fa fa-eye" : "fa fa-eye-slash"}
            onClick={props.handleShowPassword}
          />
        </div>
        {props.chk_errors("password")}
      </div>
      <div className="remember">
        <label className="check_list">
          <input type="checkbox" />
          <span className="checkmark"></span>
          Remember me
        </label>
        <a href="lost-password">Forgot password?</a>
      </div>
      <div>
        <button>Log in</button>
      </div>
    </form>

    <hr />

    <div>
      Don’t have an account?{" "}
      <b className="signup" onClick={() => props.page("signup")}>
        Sign up
      </b>
    </div>
  </div>
);

export default LoginComp;
